module.exports = __webpack_public_path__ + "img/album18_13.5bc7b4f6.jpg";